
/*------------------------------------------------------------------
Styles
------------------------------------------------------------------*/

import './../styles/style.scss';


/*------------------------------------------------------------------
External
------------------------------------------------------------------*/

import $ from 'cash-dom';
import Choices from 'choices.js';
import Flickity from './components/flickity';
import inView from 'in-view';


/*------------------------------------------------------------------
Cash debugging 
------------------------------------------------------------------*/

window.$ = $;


/*------------------------------------------------------------------
Internal - lazy loading modules by requirement
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
    if ($('.js-todo-list').length) import('./todos');
    if ($('#subscription-chart').length) import('./chart');
    if ($('.js-maintenance-item').length) import('./maintenance');
    if ($('.js-notifications-list').length) import('./notifications');
    if ($('[data-tooltip]').length) import('./tooltips');
    if ($('#start-date').length) import('./retainerHours');
    if ($('.js-subsites').length) import('./subsites');
    if ($('.js-fetch-maintenance').length) import('./schedule');
});


/*------------------------------------------------------------------
In view element manipulation
------------------------------------------------------------------*/

inView('.js-in-view').on('enter', el => { el.classList.add('inView') });


/*------------------------------------------------------------------
Fancy select elements
------------------------------------------------------------------*/

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const client = urlParams.get('client');
let $clientDropdown = $('#MaintenanceForm_MaintenanceForm_Client');

if (client && $clientDropdown.length) $clientDropdown.val(client);

if ($('select.dropdown').length) {
    $('select.dropdown').each((index, element) => {
        new Choices(element, { searchEnabled: true, itemSelectText: '' });
    });
}


/*------------------------------------------------------------------
Maintenance slider
------------------------------------------------------------------*/

const flickityOptions = {
    initialIndex: 1,
    contain: true,
    arrowShape: 'M60.7741102,19.1074435 L32.8278319,47.0537217 C31.3258154,48.5557383 31.2102757,50.919201 32.4812127,52.5537477 L32.8278319,52.9462783 L60.7741102,80.8925565 L66.6666667,75 L41.6699435,50 L66.6666667,25 L60.7741102,19.1074435 Z'
};

// if ($('.js-slider').length) new Flickity('.js-slider', flickityOptions)

    // if there are more than no js-slider classes on a page, initiate new flickity slider 
    // for each of them
if ($('.js-slider').length > 0) {
    $('.js-slider').each((index, element) => {
        new Flickity(element, flickityOptions);
    });
}

let $body = $('body');

/**
 * Set a cookie
 * @param {string} name 
 * @param {string} value 
 * @param {number} days 
 */
const setCookie = (name, value, days) => {
    let expires;

    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }

    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}


/**
 * Delete a cookie
 * @param {string} name 
 * @returns 
 */
const deleteCookie = name => setCookie(name, '', -1);


/**
 * Toggle between darkmode and save your preference as a cookie
 */

$body.on('click', '.js-dark-mode', (e) => {
    e.preventDefault();
    if ($body.hasClass('dark-mode')) {
        $body.removeClass('dark-mode');
        deleteCookie('siteguard-dark-mode');
    } else {
        setCookie('siteguard-dark-mode', 'true', 365);
        $body.addClass('dark-mode');
    }
});
